/* eslint-disable react-hooks/exhaustive-deps */
import {
  CopeStageFileUpload,
  CountdownTimer,
  CustomTable,
  FileAttachmentComponent,
  FileUploadMixSheet,
  ScrollTimePicker,
  TabToggle,
} from "#components";
import globalConfig from "#constants/globalConfig.js";
import ImagesUrl from "#constants/images.js";
import useGet from "#hooks/useGet.js";
import { TableLayout } from "#layouts";
import ENDPOINTS from "#services/endPoints.js";
import QUERY_KEYS from "#services/queryKeys.js";
import { cropPlanTableHeader, scoutingModalStep2Header } from "#utils/seeds.js";
import React, { useEffect } from "react";
const GrowerId = JSON.parse(localStorage.getItem(globalConfig.ADMIN_GROWER_ID));

const ScoutingDataList = ({
  isRunning,
  setIsRunning,
  formatTime,
  startTimer,
  stopTimer,
  time,
  cropStageInputRef,
  cropStageFiles,
  handleCropStageFileChange,
  removeCropStageFile,
  triggerCropStageFileInput,
  observationFileRef,
  handleObservationFileChange,
  handleObservationFileClick,
  handleObservationFileRemove,
  handleChange,
  handleBlur,
  values,
  errors,
  touched,
  recommendationFileRef,
  handleRecommendationFileChange,
  handleRecommendationFileClick,
  handleRecommendationFileRemove,
  mixSheetInputRef,
  mixSheetFile,
  handleMixSheetFileChange,
  handelMixSheetClick,
  handelMixSheetFileRemove,
  selectedField,
  toggleFieldRowModal,
  expandedFieldRowModal,
  setFieldValue,
  activeTab,
  setActiveTab,
  hour,
  setHour,
  setMinute,
  minute,
}) => {
  const { data: growerDetailData } = useGet(
    ENDPOINTS.GROWER_DETAIL,
    QUERY_KEYS.GROWER_DETAIL_QUERY_KEY,
    {
      growerId: GrowerId,
    }
  );
  const GrowerDetailById = growerDetailData?.data;

  const handleTabClick = async (tabName) => {
    setActiveTab(tabName);
    setFieldValue(
      "scoutTimeType",
      tabName === "Stop Watch" ? "scoutTimeTaken" : "scoutTimeTakenManual"
    );
  };
  useEffect(() => {
    setFieldValue("scoutTimeManual", `${hour}:${minute}:00`);
  }, [hour, minute]);

  return (
    <div className="common-modal-form">
      <div className="select_wrapper_card">
        <div className="row">
          <div className="col-xl-12">
            <form>
              <div className="row justify-content-between gy-3 gx-5">
                <div className="col-xl-6">
                  <div class="common-statistics">
                    <div class="common-info-detail">
                      <h2 class="h4">Grower Name</h2>
                      <p class="mb-0">{`${GrowerDetailById?.firstName} ${GrowerDetailById?.lastName}`}</p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6">
                  <div class="common-statistics">
                    <div class="common-info-detail">
                      <h2 class="h4">Phone Number</h2>
                      <p class="mb-0">
                        {`+${GrowerDetailById?.countryCode} ${GrowerDetailById?.phoneNumber}`}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="sub-heading mb-2">
            {/* <h2 className="text-start fs-4">Subject</h2> */}
          </div>
        </div>
        <div className="col-lg-12">
          <div className="d-flex gap-5">
            <div className="modal_table">
              <TableLayout
                tableHeader={cropPlanTableHeader}
                isEmpty={selectedField === null}
                pagination="true"
              >
                <CustomTable
                  tableHeader={scoutingModalStep2Header}
                  customClass="p-0"
                >
                  {selectedField?.map((item, index) => {
                    console.log(item, "mycropItem");

                    return (
                      <React.Fragment key={index}>
                        <tr
                          className="cursor-pointer position-relative"
                          key={index}
                        >
                          <td>
                            <span className="hstack gap-3">
                              {item?.subfield?.length > 0 ? (
                                <span
                                  className={`drop_icon ${
                                    expandedFieldRowModal === index
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  <img
                                    onClick={() => toggleFieldRowModal(index)}
                                    className="drop_icon"
                                    src={ImagesUrl.dopeIcon}
                                    alt="drop-icon .."
                                  />
                                </span>
                              ) : (
                                <span
                                  className={`drop_icon ${
                                    expandedFieldRowModal === index
                                      ? "active"
                                      : ""
                                  }`}
                                ></span>
                              )}

                              <span>{item?.name}</span>
                            </span>
                          </td>

                          <td>{item?.cropData[0]?.cropName || "-"}</td>
                          <td>{item?.area}</td>
                        </tr>
                        {expandedFieldRowModal === index &&
                          item?.subfield?.map((subRowData, i) => {
                            return (
                              <tr
                                className={`sub-row ${
                                  expandedFieldRowModal === index
                                    ? "expanded"
                                    : ""
                                }`}
                                key={i}
                              >
                                <td>{subRowData?.name}</td>
                                <td>{subRowData?.cropName}</td>

                                <td>-</td>
                              </tr>
                            );
                          })}
                      </React.Fragment>
                    );
                  })}
                </CustomTable>
              </TableLayout>
            </div>
            <div>
              <TabToggle
                data={["Stop Watch", "Manual"]}
                activeTab={activeTab}
                handleTabClick={handleTabClick}
              />
              {activeTab === "Stop Watch" ? (
                <CountdownTimer
                  isRunning={isRunning}
                  setIsRunning={setIsRunning}
                  formatTime={formatTime}
                  startTimer={startTimer}
                  stopTimer={stopTimer}
                  time={time}
                />
              ) : (
                <div className="col-lg-12 mt-2">
                  <ScrollTimePicker
                    hour={hour}
                    setHour={setHour}
                    minute={minute}
                    setMinute={setMinute}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <CopeStageFileUpload
        fileInputRef={cropStageInputRef}
        files={cropStageFiles}
        handleFileChange={handleCropStageFileChange}
        removeFile={removeCropStageFile}
        triggerFileInput={triggerCropStageFileInput}
        name="cropStage"
        onBlur={handleBlur}
        onChange={handleChange}
        placeholder="Enter crop stage"
        value={values?.cropStage}
      />
      <div className="row mt-4">
        <div className="col-lg-12">
          <div className="mdl_custom_field">
            <div>
              {values?.observation?.map((item, i) => (
                <FileAttachmentComponent
                  key={i}
                  label={`Observation ${i + 1}`}
                  files={item.observationFiles}
                  fileInputRef={observationFileRef}
                  handleFileChange={(e) => handleObservationFileChange(e, i)}
                  handleFileClick={() => handleObservationFileClick(i)}
                  handleFileRemove={(file, url) =>
                    handleObservationFileRemove(file, url, i)
                  }
                  handelChange={handleChange}
                  name={`observation[${i}].observation`}
                  placeholder="Type here .."
                  onBlur={handleBlur}
                  value={item.observation}
                  error={errors?.observation?.[i]?.observation}
                  touched={touched?.observation?.[i]?.observation}
                  i={i}
                />
              ))}
              <div className="d-flex ">
                <button
                  type="button"
                  className="btn primary-btn mt-3"
                  onClick={() => {
                    setFieldValue("observation", [
                      ...(values.observation || []),
                      {
                        observation: "",
                        observationFiles: [],
                        removeObservationFiles: [],
                      },
                    ]);
                  }}
                >
                  Add Observation
                </button>
              </div>
            </div>

            {/* <div className="mt-3">
              <FileAttachmentComponent
                label="Recommendation"
                files={recommendationFile}
                fileInputRef={recommendationFileRef}
                handleFileChange={handleRecommendationFileChange}
                handleFileClick={handleRecommendationFileClick}
                handleFileRemove={handleRecommendationFileRemove}
                handelChange={handleChange}
                name="recommendation"
                placeholder="Type here .."
                onBlur={handleBlur}
                value={values.recommendation}
                error={errors.recommendation}
                touched={touched.recommendation}
              />
            </div> */}
            <div className="mt-3">
              {/* <FileAttachmentComponent
                label="Recommendation"
                files={recommendationFile}
                fileInputRef={recommendationFileRef}
                handleFileChange={handleRecommendationFileChange}
                handleFileClick={handleRecommendationFileClick}
                handleFileRemove={handleRecommendationFileRemove}
                handelChange={handleChange}
                name="recommendation"
                placeholder="Type here .."
                onBlur={handleBlur}
                value={values.recommendation}
                error={errors.recommendation}
                touched={touched.recommendation}
              /> */}

              {values.recommendation?.map((item, i) => (
                <FileAttachmentComponent
                  key={i}
                  label={`Recommendation ${i + 1}`}
                  files={item.recommendationFiles}
                  fileInputRef={recommendationFileRef}
                  handleFileChange={(e) => handleRecommendationFileChange(e, i)}
                  handleFileClick={() => handleRecommendationFileClick(i)}
                  handleFileRemove={(fileIndex, url) =>
                    handleRecommendationFileRemove(fileIndex, url, i)
                  }
                  handelChange={handleChange}
                  name={`recommendation[${i}].recommendation`}
                  placeholder="Type here .."
                  onBlur={handleBlur}
                  value={item.recommendation}
                  error={errors?.recommendation?.[i]?.recommendation}
                  touched={touched?.recommendation?.[i]?.recommendation}
                  i={i}
                />
              ))}
              <div className="d-flex">
                <button
                  type="button"
                  className="btn primary-btn mt-3"
                  onClick={() => {
                    const newRecommendations = [
                      ...values.recommendation,
                      {
                        recommendation: "",
                        recommendationFiles: [],
                        removeRecommendationFiles: [],
                      },
                    ];
                    setFieldValue("recommendation", newRecommendations);
                  }}
                >
                  Add Recommendation
                </button>
              </div>
            </div>
            {/* <div>
              <FileUploadMixSheet
                fileInputRef={mixSheetInputRef}
                fileName={mixSheetFile}
                handleFileChange={handleMixSheetFileChange}
                triggerFileInput={handelMixSheetClick}
                handleFileRemove={handelMixSheetFileRemove}
              />
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScoutingDataList;
